// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"C8-z"};